import * as firebase from 'firebase'
import 'firebase/firestore'

const db = firebase.firestore()
db.settings({ timestampsInSnapshots: true })
db.enablePersistence()

export default db



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/db.ts